

import {typesOrderdet} from './svtypes/orderdetTypes'

import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'

let initStore = {
    loading: false,
    error: false,
    my_data: [],
    loadingORDERDET:false,
    errorORDERDET:false,
    errob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
  
    my_data_review:{
        "Request": {
            "checkin": "OK",
            "stay": "6",
            "stayInit": "nights",
            "checkout": "UU12345",
            "checkinTime": "Sat, Sept 9, 3027",
            "checkinTimePrefix": "From 3:00 PM",
            "checkoutTimePrefix": "Until 11:00 AM",
            "checkoutTime": "Sat, Sept 16, 3027"
        },
        "spaceDet": {
        
            "space_details": "Queen Room with Two Queen Beds",
            "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
            "cancellation": "Free cancellation before December 9, 2024 ",
            "guests": "2 adults ",
            "cleaniness_score" : "7.7",
            "non_smoking":true,
    
            "space_amenity_name": [
                "300 feet elevator",
                "air conditioning",
                "private bathroom"
            ]
           
           
        },
        "booking": {
            "resort_name": "Cambria Hotel Orlando Airport",
            "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
            "stayDet": "6 nights",
            "num_reviews": 101,
            "amenity_name": [
                "HotTub",
                "Spa",
                "Swimming pool",
                "Laundry"
            ],
            "num_reviews_label": "Good, ",
            "rating_detail":" Excellebt, 9.1",
            "num_reviews_detail": "Good, 101 reviews"
           
        },
        "price": {
            "total": "$923",
            "depositValue":"$200.26",
            "depositName":"Damage Deposit (Fully refundable)",
            "currency": "usd",
            "tax": {
               
                "taxTotal": "$102.34",
                "maintax": "$49.08",
                "citytax": "$53.26",
    
                "taxPercent": "6",
                "citytaxPercent": "6.5"
            }
        },
        "id": "addLeft_step",
        "gene": "addLeft_step",
        "dcountry": "China",
        "privateparking":false,
        "rentcar":false,
        "bookTaxi":false,
        "needFlight":false,
        "arrivalTimeZone":"tz_pst",
        "fname": "John",
        "lname": "Glen",
        "email": "john123@yahoo.com",
        "address": "Glen",
        "city": "Glen",
        "state": "Glen",
        "zip": "12110",
        "country": "Glen",
        "isdcode": "+1",
        "phone": "Glen",
        "bookingAgentType": "self",
        "traveType": "Personal",
        "specialRequests": "Wheel chair and Senior Citizen",
        "gname": "Glen",
        "gemail": "Glen@yahoo.com",
        "card": "1234-1234--1234--1234",
        "cvv": "Glen",
        "mmexp": "04",
        "yyyyexp": "2028"
    }
   
    
   
    
}

export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
        
        
        case 'GET_ORDERDET_SUCCESS':
            console.log("reduce %%%%%%%%GET_ORDERDET_SUCCESS  success*****************");
            console.log(action.payload.my_data_review);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            januState = {...state, loadingORDERDET: false, my_data_review: action.payload.my_data_review}
            return januState
        case 'GET_ORDERDET_BEGIN':
                console.log("loading")
                return {...state, loadingORDERDET: true}
        case 'GET_ORDERDET_ERROR':
            console.log("error")
            console.log(action.payload.errob)
            const errjson = {
                "timestamp": "2024-08-23T02:27:18.038+0000",
                "status": 500,
                "error": "Internal Server Error",
                "message": "500 null",
                "path": "/accountclient/svaddressDetailPost"
            }
            return {...state,errob:action.payload.errob, errorORDERDET: true}
     
               
        
        
        default:
            return state
    }
}